var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row mb-4" }, [
        _vm.faq_categories
          ? _c(
              "div",
              { staticClass: "col-10 offset-1 text-center" },
              _vm._l(_vm.faq_categories, function(faq_category) {
                return _c(
                  "div",
                  {
                    key: faq_category.id,
                    class: [
                      _vm.category == faq_category.id ? "active" : "",
                      "faq-filter"
                    ],
                    on: {
                      click: function($event) {
                        _vm.setCategory(faq_category.id)
                        _vm.calculatePagesBefore(_vm.pagination.current_page)
                        _vm.calculatePagesAfter(_vm.pagination.current_page)
                        _vm.goToFirstPage()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " + _vm._s(faq_category.name) + "\n        "
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.faq
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2"
              },
              [
                _c(
                  "div",
                  { staticClass: "accordion", attrs: { id: "faq-accordion" } },
                  _vm._l(_vm.faq, function(article) {
                    return _c("div", { key: article.id, staticClass: "card" }, [
                      _c(
                        "div",
                        {
                          staticClass: "card-header",
                          attrs: { id: "headingTwo" }
                        },
                        [
                          _c("h5", { staticClass: "mb-0" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link collapsed",
                                attrs: {
                                  "data-toggle": "collapse",
                                  "data-target": "#faq-" + article.id,
                                  "aria-expanded": "false",
                                  "aria-controls": "faq-" + article.id
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(article.title) +
                                    "\n                  "
                                ),
                                _c("div", { staticClass: "arrow" })
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "collapse",
                          attrs: {
                            id: "faq-" + article.id,
                            "aria-labelledby": "headingTwo",
                            "data-parent": "#faq-accordion"
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "card-body",
                            domProps: { innerHTML: _vm._s(article.content) }
                          })
                        ]
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid text-center" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-10 offset-1 py-4 my-3",
            attrs: { id: "pagination" }
          },
          [
            _vm.pagination.total_pages > 1
              ? _c(
                  "div",
                  { staticClass: "wp-pagenavi" },
                  [
                    _c("span", { staticClass: "pages" }, [
                      _vm._v(
                        "Page " +
                          _vm._s(_vm.pagination.current_page) +
                          " of " +
                          _vm._s(_vm.pagination.total_pages)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.pagination.current_page > 2
                      ? _c(
                          "a",
                          {
                            staticClass: "first",
                            attrs: {
                              href:
                                _vm.pagination.base_url +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-double-left" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pagination.current_page > 1
                      ? _c(
                          "a",
                          {
                            staticClass: "previouspostslink",
                            attrs: {
                              rel: "prev",
                              href:
                                _vm.pagination.base_url +
                                "page/" +
                                (parseInt(_vm.pagination.current_page) - 1) +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-left" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.pagesBefore, function(page) {
                      return _c(
                        "a",
                        {
                          key: page,
                          staticClass: "page smaller",
                          attrs: {
                            title: "Page " + page,
                            href:
                              _vm.pagination.base_url +
                              "page/" +
                              page +
                              "?category=" +
                              _vm.category
                          }
                        },
                        [
                          _vm._v(
                            "\n              " + _vm._s(page) + "\n          "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "current" }, [
                      _vm._v(_vm._s(_vm.pagination.current_page))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.pagesAfter, function(page) {
                      return _c(
                        "a",
                        {
                          key: page,
                          staticClass: "page smaller",
                          attrs: {
                            title: "Page " + page,
                            href:
                              _vm.pagination.base_url +
                              "page/" +
                              page +
                              "?category=" +
                              _vm.category
                          }
                        },
                        [
                          _vm._v(
                            "\n              " + _vm._s(page) + "\n          "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.pagination.current_page < _vm.pagination.total_pages
                      ? _c(
                          "a",
                          {
                            staticClass: "nextpostslink",
                            attrs: {
                              rel: "next",
                              href:
                                _vm.pagination.base_url +
                                "page/" +
                                (parseInt(_vm.pagination.current_page) + 1) +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-right" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pagination.current_page < _vm.pagination.total_pages - 1
                      ? _c(
                          "a",
                          {
                            staticClass: "last",
                            attrs: {
                              href:
                                _vm.pagination.base_url +
                                "page/" +
                                _vm.pagination.total_pages +
                                "?category=" +
                                _vm.category
                            }
                          },
                          [_c("i", { staticClass: "fa fa-angle-double-right" })]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/arthur.cruz/BRNDWGN/Projects/mz-marketing-wp/web/app/themes/mz-marketing/node_modules/vue-loader/lib?{}!./scripts/vue/faqs.vue?vue&type=template&id=a928279e&
// module id = 83
// module chunks = 0